import React, { useState } from 'react';
import { marked } from 'marked';
import axios from 'axios';
import './HomePage.css';



const HomePage = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [acceptanceCriteria, setAcceptanceCriteria] = useState('');
  const [loading, setLoading] = useState(false);

  console.log("inside APP.js")

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);  // Set loading to true before making the API call

    try {
      console.log("before calling api");
      // Generate acceptance criteria using OpenAI API
      const response = await axios.post(
        'https://api.openai.com/v1/chat/completions', // Make sure the model ID is correct, 
        {
          model: "gpt-4o-mini",
          messages: [
            {
              "role": "system",
              "content": "You are a senior product manager with 30+ years writing user stories and acceptance criterias"
            },
            {
              "role": "user",
              "content": `Generate plain text acceptance criteria for the following JIRA ticket. Ensure the response is complete and clear.\n\nTitle: ${title}\nDescription: ${description}`
            }
          ],
          max_tokens: 1000,
          temperature: 0.7, // Optional: Adjusts randomness of the responses
        },
        {
          headers: {
            'Authorization': `Bearer sk-svcacct-DyVNJ7V0xsSCXxlNofxiT3BlbkFJmZF7VQkmVC7t4Ngj2W9k`,
            "Content-Type" : "application/json"
          },
        }
      );

      console.log("response is:",response)

      // Extract the generated acceptance criteria from the response
      let generatedCriteria = response.data.choices[0].message.content.trim();
      setAcceptanceCriteria(generatedCriteria);
      setLoading(false);  // Set loading to false after receiving the response
    }
    catch (error) {
      console.error("Failed to generate criteria:", error);
      alert("Failed to generate criteria. Check console for more details.");
      setLoading(false);  // Set loading to false if there is an error
    }
};

const handleClear = () => {
  setTitle('');
  setDescription('');
  setAcceptanceCriteria('');
};

  return (
    <div className="app">
      <header className="app-header">
        <h1>JIRA Acceptance Criteria Generator</h1>
        <p>Enter the details of your JIRA ticket below to generate a clear and crisp acceptance criteria for your User Story.</p>
      </header>
      <form className="input-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <label htmlFor="title">JIRA Ticket Title:</label>
          <input
            id="title"
            type="text"
            value={title}
            onChange={e => setTitle(e.target.value)}
            placeholder="Enter Title"
            required
          />
        </div>
        <div className="input-group">
          <label htmlFor="description">JIRA Ticket Description:</label>
          <textarea
            id="description"
            value={description}
            onChange={e => setDescription(e.target.value)}
            placeholder="Enter a clear and concise Description for your User Story."
            required
          />
        </div>
        <div className="button-group">
          <button type="submit" className="submit-button">Generate</button>
          <button type="button" className="clear-button" onClick={handleClear}>Clear</button>
        </div>
      </form>
      {loading ? (
        <div className="loader"></div>
      ) : acceptanceCriteria && (
        <div className="output">
          <h2>Acceptance Criteria:</h2>
          <div
            className="criteria-output"
            dangerouslySetInnerHTML={{ __html: marked(acceptanceCriteria) }}
          />
        </div>
      )}
    </div>
  );
};

export default HomePage;
